// src/components/landing/HowItWorks.tsx
'use client'

import { ClipboardCheck, Sparkles, Rocket } from 'lucide-react'

type Step = {
  n: number
  icon: React.ReactNode
  title: string
  text: string
  accent: string
  ring: string
}

const STEPS: Step[] = [
  {
    n: 1,
    icon: <ClipboardCheck className="h-6 w-6 text-brand-ink" />,
    title: 'Take a diagnostic',
    text: 'Short free test shows your baseline.',
    accent: 'text-brand-ink',
    ring: 'ring-brand/20',
  },
  {
    n: 2,
    icon: <Sparkles className="h-6 w-6 text-brand-ink" />,
    title: 'Get your personalized plan',
    text: 'AI identifies weak areas and creates a study schedule.',
    accent: 'text-brand-ink',
    ring: 'ring-brand/20',
  },
  {
    n: 3,
    icon: <Rocket className="h-6 w-6 text-emerald-700 dark:text-emerald-300" />,
    title: 'Practice and improve',
    text: 'Unlimited tests, spaced repetition, and AI tutor chat.',
    accent: 'text-emerald-700 dark:text-emerald-300',
    ring: 'ring-emerald-500/20',
  },
]

export default function HowItWorks() {
  return (
    <section className="px-5 py-14 md:px-10">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-3 text-center text-2xl font-semibold text-foreground md:text-3xl">
          How it works
        </h2>
        <p className="mb-10 text-center text-sm text-muted-foreground">
          Three steps from first click to score jump.
        </p>
        <ol className="grid gap-5 md:grid-cols-3">
          {STEPS.map((s) => (
            <li
              key={s.n}
              className={`relative rounded-2xl border border-border bg-card/60 p-6 ring-1 ${s.ring}`}
            >
              <div className="mb-4 flex items-center justify-between">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-border bg-card">
                  {s.icon}
                </div>
                <span
                  className={`text-5xl font-bold leading-none opacity-30 ${s.accent}`}
                  aria-hidden
                >
                  {s.n}
                </span>
              </div>
              <h3 className="text-lg font-semibold text-foreground">{s.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{s.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
